import { render, staticRenderFns } from "./request-memory-row.vue?vue&type=template&id=64580b7f"
import script from "./request-memory-row.vue?vue&type=script&lang=js"
export * from "./request-memory-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports